// import apiPaths from '@/Configs/api-paths';
import { useCallback } from "react";
// import contentApi from "@/Services/api";
import apiPaths from "../../../api/endpoints";
import apiClientTwo from "../../../api/apiClient2";

export const useRetrieveSelQuestions = () => {
  const retrieveSelQuestions = useCallback(async (documentId: string) => {
    return apiClientTwo
      .get(`${apiPaths.FETCH_SEL_QUESTIONS}/${documentId}`)
      .then((r) => r.data)
      .catch((e) => e);
  }, []);
  return { retrieveSelQuestions };
};

export const usePostSelQuestions = () => {
  const postSelQuestions = useCallback(async (params: unknown) => {
    return apiClientTwo
      .post(apiPaths.POST_SEL_QUESTIONS, params)
      .then((r) => r.data)
      .catch((e) => e);
  }, []);
  return { postSelQuestions };
};

export const useRetrieveStory = () => {
  const retrieveStoryData = useCallback(async (endPoint?: string) => {
    return apiClientTwo
      .get(
        endPoint
          ? `${apiPaths.RETRIEVE_STORY}${endPoint}`
          : `${apiPaths.RETRIEVE_STORY}`,
      )
      .then((response: any) => {
        return response.data;
      })
      .catch((error: Error) => {
        return error;
      });
  }, []);
  return {
    retrieveStoryData,
  };
};

export const usePostStoryData = () => {
  const PostStoryData = useCallback(async (data: any) => {
    return apiClientTwo
      .put(`${apiPaths.POST_STORY_UPDATE}`, data)
      .then((response: any) => {
        if (response.status !== 200) {
          throw new Error("Failed to fetch");
        }
        return response?.data;
      })
      .catch((error: Error) => {
        throw error;
      });
  }, []);
  return {
    PostStoryData,
  };
};

export const useTemplateList = () => {
  const retrieveTemplateList = useCallback(() => {
    return apiClientTwo
      .get(`${apiPaths.RETRIEVE_TEMPLATE_LIST}`)
      .then((response: any) => {
        return response.data;
      })
      .catch((error: Error) => {
        return error;
      });
  }, []);
  return {
    retrieveTemplateList,
  };
};
